// Reuse log bodies only after the server authenticates and revalidates them.
const storageKey = 'corecry:log-response:v1'
let memory = null

export function readLogResponse(path) {
  try {
    const saved = memory || JSON.parse(sessionStorage.getItem(storageKey) || 'null')
    if (saved?.path === path && typeof saved.etag === 'string' && saved.data &&
        Date.now() - saved.savedAt < 30 * 60 * 1000) return saved
  } catch { /* Storage is optional; a full response is always safe. */ }
  return null
}

export function saveLogResponse(path, etag, data) {
  if (!etag) return
  memory = { path, etag, data, savedAt: Date.now() }
  try {
    const encoded = JSON.stringify(memory)
    sessionStorage.removeItem(storageKey)
    sessionStorage.setItem(storageKey, encoded)
  } catch { /* Keep the in-memory response when storage is unavailable/full. */ }
}

export function clearLogResponse() {
  memory = null
  try { sessionStorage.removeItem(storageKey) } catch { /* Optional cache. */ }
}
